import {formatMessage} from '@/libs/intlHelper.jsx';

import {Loading} from '../../constants/actionType';

export const showLoading =
  (text, callback = undefined) =>
  (dispatch, getState) => {
    const {loadingState} = getState();

    if (!loadingState.show) {
      const loading = {
        show: true,
        text: text || formatMessage({id: 'loading.default.message'}),
      };

      dispatch({type: Loading.SHOW, loading});
    } else {
      dispatch({type: Loading.CHANGE_TEXT, text});
    }

    if (callback) callback();
  };

export const hideLoading = () => (dispatch, getState) => {
  const {loadingState} = getState();

  if (loadingState.show) {
    dispatch({type: Loading.HIDE});
  }
};

export const changeLoadingText = (text) => (dispatch) => {
  dispatch({type: Loading.CHANGE_TEXT, text});
};
